export enum ServiceOrderDocumentType {
  CUSTOMER_COPY = "CUSTOMER_COPY",
  WORK_ORDER = "WORK_ORDER",
}
